
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const TeacherStudentModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    students: Array,
    teacherId: Number
  }
})

@Component
export default class TeacherStudentModal extends TeacherStudentModalProps {
  data () {
    return {
      isLoading: false,
      selectedStudentId: null,
      formDataValid: false
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['selectedStudentId'], function () {
      const valid = this.$refs.form.checkValidity()
      this.formDataValid = valid
    })
  }

  async addStudentToTeacher () {
    try {
      this.isLoading = true

      var data = {
        teacherId: this.teacherId,
        studentId: this.selectedStudentId
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/addStudentToTeacher`, data)

      this.isLoading = false

      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Student added.',
        onConfirm: () => {
          this.$emit('created')
          this.selectedStudentId = null
          this.formDataValid = false
        },
        canCancel: false
      })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not add. Reason: ${e}`,
        canCancel: false
      })
    }
  }
}
